export const PLOOM_EDITOR_FONT_FORMATS = [
  "Pre-Titlu - Open Sans=Open Sans,sans-serif",
  "Titlu - Times NR MT Regular=Times NR MT Regular,Times New Roman,serif",
  "Subtitlu - TNR MT Regular Italic=TNR MT Regular Italic,Times New Roman,serif",
  "Text - Montserrat=Montserrat,sans-serif",
].join(";");

export const PLOOM_EDITOR_STYLE_FORMATS = [
  { title: "Pre-Titlu", block: "p", classes: "ploom-pretitle" },
  { title: "Titlu", block: "h2", classes: "ploom-title" },
  { title: "Subtitlu", block: "h3", classes: "ploom-subtitle" },
  { title: "Text", block: "p", classes: "ploom-body" },
];

const readDesignToken = (token, fallback) => {
  if (typeof window === "undefined") return fallback;
  return getComputedStyle(document.documentElement).getPropertyValue(token).trim() || fallback;
};

export const getPloomEditorColorMap = () => [
  readDesignToken("--color-ploom", "currentColor"), "Ploom",
  readDesignToken("--color-ploom-dark", "currentColor"), "Ploom închis",
  readDesignToken("--color-ploom-light", "white"), "Ploom deschis",
  readDesignToken("--color-text-black", "black"), "Titlu",
  readDesignToken("--color-text-dark", "black"), "Text închis",
  readDesignToken("--color-text-body", "dimgray"), "Text",
  readDesignToken("--color-text-muted", "gray"), "Text secundar",
  readDesignToken("--color-text-subtle", "gray"), "Text discret",
  readDesignToken("--bg-white", "white"), "Alb",
];

export const getPloomEditorContentStyle = () => {
  const ploom = readDesignToken("--color-ploom", "currentColor");
  const white = readDesignToken("--bg-white", "white");
  const black = readDesignToken("--color-text-black", "black");
  const body = readDesignToken("--color-text-body", "dimgray");

  return `
    body { margin: 28px; background: ${white}; font-family: Montserrat, sans-serif; font-size: 16px; line-height: 1.7; color: ${body}; }
    p { font-family: Montserrat, sans-serif; font-size: 16px; line-height: 1.7; color: ${body}; }
    p.ploom-pretitle { margin: 0 0 28px; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 400; letter-spacing: 7px; line-height: 1.5; text-transform: uppercase; color: ${ploom}; }
    h2, h2.ploom-title { margin: 32px 0 18px; font-family: 'Times NR MT Regular', 'Times New Roman', serif; font-size: 42px; font-weight: 400; letter-spacing: .005em; word-spacing: -.06em; line-height: .95; color: ${black}; }
    h3, h3.ploom-subtitle { margin: 26px 0 16px; font-family: 'TNR MT Regular Italic', 'Times New Roman', serif; font-size: 32px; font-style: italic; font-weight: 400; letter-spacing: .005em; word-spacing: -.04em; line-height: 1; color: ${ploom}; }
  `;
};

const isUppercaseText = (text) => {
  const letters = String(text || "").replace(/[^A-Za-zĂÂÎȘȚăâîșț]/g, "");
  return letters.length >= 2 && letters === letters.toLocaleUpperCase("ro-RO");
};

const TYPOGRAPHY_STYLE_PROPERTIES = [
  "color",
  "font-family",
  "font-size",
  "font-style",
  "font-weight",
  "letter-spacing",
  "line-height",
  "text-transform",
  "word-spacing",
];

const PLOOM_TYPOGRAPHY_CLASSES = [
  "ploom-pretitle",
  "ploom-title",
  "ploom-subtitle",
  "ploom-body",
];

const resetInlineTypography = (element) => {
  TYPOGRAPHY_STYLE_PROPERTIES.forEach((property) => element.style.removeProperty(property));
  if (!element.getAttribute("style")?.trim()) element.removeAttribute("style");
};

const applyTypographyRole = (element, role) => {
  resetInlineTypography(element);
  element.classList.remove(...PLOOM_TYPOGRAPHY_CLASSES);
  element.classList.add(role);
};

const isTextOnlyContainer = (element) =>
  !element.querySelector("div, p, h1, h2, h3, h4, h5, h6, ul, ol, blockquote, table");

export const normalizeBlogTypography = (html) => {
  if (!html || typeof DOMParser === "undefined") return html || "";

  const parsed = new DOMParser().parseFromString(`<div id="blog-typography-root">${html}</div>`, "text/html");
  const root = parsed.getElementById("blog-typography-root");
  if (!root) return html;

  root.querySelectorAll("*").forEach(resetInlineTypography);

  root.querySelectorAll("p").forEach((paragraph) => {
    applyTypographyRole(
      paragraph,
      isUppercaseText(paragraph.textContent) ? "ploom-pretitle" : "ploom-body"
    );
  });
  root.querySelectorAll("li").forEach((listItem) => {
    applyTypographyRole(
      listItem,
      isUppercaseText(listItem.textContent) ? "ploom-pretitle" : "ploom-body"
    );
  });
  root.querySelectorAll("div").forEach((container) => {
    if (!isTextOnlyContainer(container) || !container.textContent.trim()) return;
    applyTypographyRole(
      container,
      isUppercaseText(container.textContent) ? "ploom-pretitle" : "ploom-body"
    );
  });
  root.querySelectorAll("h2").forEach((heading) => {
    applyTypographyRole(heading, "ploom-title");
  });
  root.querySelectorAll("h3").forEach((heading) => {
    applyTypographyRole(heading, "ploom-subtitle");
  });

  return root.innerHTML;
};
